import { Link } from 'react-router-dom';

/**
 * Kaki halaman — hak cipta, di dasar setiap halaman (1 September 2026).
 *
 * **Setinggi mungkin mendekati nol**, dan itu syarat, bukan selera. Bilah atas
 * pernah dibongkar karena memakan ±61px di setiap halaman untuk dua kendali
 * (§G9), dan yang membayarnya gambar kamera di `/dashboard` — halaman yang
 * seluruh alasan keberadaannya justru gambar itu (§G7 no.1). Baris ini 11px
 * dengan padding 2px: ±20px, sepertiga bilah Wall Status, dan tidak ada
 * apa-apa lagi yang boleh menumpang di sini nanti.
 *
 * Ia duduk **di luar** `<main>`, sebagai saudara sebelahnya. Di dalam `<main>`
 * ia akan ikut menggulung — dan di halaman yang isinya lebih panjang dari satu
 * layar (Logs, Cameras) itu berarti tulisan hak cipta yang cuma bisa dilihat
 * dengan menggulung sampai dasar 96 baris tabel.
 *
 * Tahunnya **ditulis, bukan `getFullYear()`**. Tahun hak cipta itu fakta
 * redaksional, bukan keadaan runtime: box yang jam sistemnya melenceng — dan
 * di jaringan tanpa NTP itu bukan hal langka — akan mencetak tahun yang salah
 * di setiap halaman tanpa satu orang pun memutuskannya.
 */
const TAHUN = 2026;

/**
 * Kalimatnya sendiri, diekspor.
 *
 * Ia muncul di tiga tempat — kaki halaman, halaman About, dan `/login` yang
 * berdiri di luar gerbang auth sehingga kaki halaman tidak menjangkaunya. Tiga
 * salinan yang diketik sendiri-sendiri adalah tiga nama perusahaan yang bisa
 * berbeda, dan yang paling mungkin berbeda justru titik sesudah "PT".
 */
export const HAK_CIPTA = `© ${TAHUN} PT. Sandya Sistem Indonesia`;

export function AppFooter() {
  return (
    <footer className="flex shrink-0 items-center justify-center gap-2 border-t border-line bg-surface px-3 py-1 text-[11px] leading-4 text-muted">
      {/* Tautan ke About duduk di sini, bukan sebagai baris kedua: satu-satunya
          halaman yang isinya "aplikasi apa ini" memang paling dicari orang dari
          tulisan namanya sendiri. */}
      <Link to="/about" className="rounded hover:underline">
        {HAK_CIPTA}
      </Link>
    </footer>
  );
}
